import Tool, { type IToolActionInput, type IToolAvailableInput } from './Tool';
import { isSimpleSelection } from '../objects/guards';
import Shortcut from '../utils/Shortcut';

class ToolBringForward extends Tool {
  static toolName = 'Bring forward';
  static shortcut = new Shortcut('Shift+pageup');

  static action({ controller, selection }: IToolActionInput) {
    selection.bringForward();
    this.toolActionComplete({ controller });
  }

  static available({ selection }: IToolAvailableInput) {
    return !!(
      selection &&
      selection.type !== 'comment' &&
      !isSimpleSelection(selection)
    );
  }
}

export default ToolBringForward;
